import { motion } from 'framer-motion';

export type RotateProps = {
  degrees?: number;
  isRotated?: boolean;
};

export const Rotate: React.FC<RotateProps> = ({ isRotated = false, degrees = 90, ...rest }) => (
  <motion.div
    animate={{ rotate: isRotated ? degrees : 0 }}
    transition={{ duration: 0.2 }}
    style={{ display: 'flex' }}
    {...rest}
  />
);
